import axios from "axios";
import { API_URL } from "../env";

// Must stay interceptor-free. The backend falls back to machine credentials only for
// unauthenticated requests, so any forwarded Authorization header breaks registration.
const anonymousClient = axios.create({
  baseURL: API_URL,
  timeout: 180000,
});

export default anonymousClient;
